export const regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;
export const regexEmail = /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}$/;
export const regexNumber = /^[0-9]$/;